import { makeEmailStatuses } from 'domains/userSettings/utils/makeEmailStatuses';
import { useAuth } from 'modules/auth/hooks/useAuth';
import { useBoundEmails } from 'domains/userSettings/hooks/useBoundEmails';

export const useEmailData = () => {
  const { isLoggedIn } = useAuth();

  const { emails, loading: isLoadingBoundEmails } = useBoundEmails({
    skipFetching: !isLoggedIn,
  });

  const { confirmedEmail, pendingEmail } = makeEmailStatuses(emails);

  return {
    confirmedEmail,
    isLoading: isLoadingBoundEmails,
    pendingEmail,
  };
};
